import React from 'react';

const DoctorsMessagePattern = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%"
      height="100%"
      viewBox="0 0 1440 531" fill="none">
      <path d="M0 0H485.347C591.63 297.44 340.263 603.079 0 437.185V0Z" fill="#7F4A9B" />
      <path d="M1440 531H1294.4C1262.51 441.276 1337.92 349.08 1440 399.122V531Z" fill="#7F4A9B" />
    </svg>
  );
};

export default DoctorsMessagePattern;